module.exports = __webpack_public_path__ + "img/shop-InfoHead.04c565a3.jpg";